var tinymceInit = false;
var editorId;

function switchEditor (layer, id, cfg) {
  layer = layer || $('.markdown-layer');
  var isHtml = !layer.find('input[name=editorType]').prop('checked');

  if (isHtml) {
     layer.find('.markdown-field').hide();
     layer.find('.tinymce-field').show();
    if (tinymceInit) {
      ////
    } else {
      id = id || 'editor';
      require('./editor')(id, cfg);
      tinymceInit = true;
    }
  } else {
    layer.find('.tinymce-field').hide();
    layer.find('.markdown-field').show();
  }
}


$('.markdown-layer input[name=editorType]').on('change', function () {
  var layer = $(this).closest('.markdown-layer');
  layer.find('.markdown-op').toggle();
  switchEditor(layer, editorId);
}); 


module.exports = function (id, cfg) {
  editorId = id;
  switchEditor('', editorId, cfg);
}


// WEBPACK FOOTER //
// ./src/app/switch.js